var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"ps-fx ps-t0 ps-r0 ds-ib pd0 mr0 z-10 twidth30"}),(_vm.isRefresh)?_c('button',[_vm._v("새 버전이 있습니다.")]):_vm._e(),(_vm.hub)?_c('HeaderHub'):_c('Header'),_c('router-view'),_c('OverallComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }